import { PeriodicityOfContributionEntity } from '../entities/periodicity-of-contribution-entity';

export default class State {
  loaded = false;

  items: Array<PeriodicityOfContributionEntity> = [];
}
